import React from 'react';
import setCookie from '../../cookie/setCookie';
import { Checkbox } from 'antd';
import { FormattedMessage,   injectIntl } from 'react-intl';
import queryString from 'query-string'

const divStyle = {
  position: 'absolute',
  bottom: '5px',
  right: '10px',
  color: 'white',
};

const closeWin = () => {
  setCookie('popup_addSNSLink', 'done', 1);
  setTimeout(() => window.close(), 500);
};

const getLanguage = (props) => {
  const { search } = props.location;
  const { lang } = queryString.parse(search);

  if (['en', 'ko'].includes(lang)) {
    return lang;
  }
  
  return props.intl.locale;
}

let AddSNSLinkPopup = (props) => (
  <div style={{ width: '100vw', height: '100vh' }}>
    <img src={require(`../../img/event/add_link_${getLanguage(props)}.png`).default} width="100%" height="100%" alt="" />
    <img src={require(`../../img/event/add_link_button_${getLanguage(props)}.png`).default} style={{ width:"62.5%", position: 'fixed', bottom: '11%', left: '50%', transform: 'translate(-50%, 0)' }} onClick={() => {
      setTimeout(() => window.close(), 100);
      const openerWindow = window.opener;
      openerWindow.document.location.href = "/mypage/setting";
    }} />
    {/* 하루동안 열지 않기 */}
    <Checkbox onChange={() => closeWin()} style={divStyle}>
      <FormattedMessage id={'PopUp.closeWindow.text'} defaultMessage={'Do not open this window for a day'} />
    </Checkbox>
  </div>
);
 
AddSNSLinkPopup = injectIntl(AddSNSLinkPopup);
export default AddSNSLinkPopup;
